module.exports = __webpack_public_path__ + "img/benefit-2-hover.40166802.png";